import React from 'react';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';
import { dateFn } from '../../utils/dateTimeFormatter';
import { amountCheckFn } from '../../utils/commonUtil';
import { capitalCaseFormatter } from '../../utils/stringFormatters';

export default function Transactions({ invoice, invoiceLoading }) {
  const transactions = invoice?.transactions || [];

  return (
    <div className='mt-4 rounded-lg bg-white sm:mt-6 '>
      {invoiceLoading ? (
        <Loader text='loading transactions...' classes='h-96' />
      ) : transactions?.length === 0 ? (
        <NoData text='No transactions found' classes='h-96' />
      ) : (
        <React.Fragment>
          <header className='flex items-center border-b border-gray-100 p-4 pl-5 align-top'>
            <h5 className='go-textblackmedium-18 my-1 flex-1'>Transactions</h5>
          </header>
          {/* Desktop Table View */}
          <div className='hidden w-full overflow-x-auto sm:block'>
            <table className='w-full divide-y divide-slate-100'>
              <thead className='border-b border-slate-200'>
                <tr>
                  <th className='go-textblack-14 px-4 py-3 text-left sm:px-8'>ID</th>
                  <th className='go-textblack-14 px-4 py-3 text-left sm:px-8'>Type</th>
                  <th className='go-textblack-14 px-4 py-3 text-right sm:px-8'>Amount</th>
                  <th className='go-textblack-14 px-4 py-3 text-center sm:px-8'>Date</th>
                </tr>
              </thead>
              <tbody>
                {transactions?.map((tx, idx) => (
                  <tr key={idx}>
                    <td className='go-textblacknormal-14 px-4 py-3 sm:px-8'>{tx?.transaction_id}</td>
                    <td className='go-textblacknormal-14 px-4 py-3 sm:px-8'>{capitalCaseFormatter(tx?.type)}</td>
                    <td className='go-textblacknormal-14 px-4 py-3 text-right sm:px-8'>
                      {amountCheckFn(tx?.net_amount)}
                    </td>
                    <td className='go-textblacknormal-14 px-4 py-3 text-center sm:px-8'>
                      {dateFn('MM/DD/YYYY', tx?.created_date)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Mobile Card View */}
          <div className='divide-y divide-slate-100 sm:hidden'>
            {transactions?.map((tx, idx) => (
              <div key={idx} className='p-4'>
                <div className='flex items-center justify-between'>
                  <span className='go-textblack-14'>{tx?.transaction_id}</span>
                  <span className='go-textblack-14'>{amountCheckFn(tx?.net_amount)}</span>
                </div>
                <div className='mt-2 flex items-center justify-between'>
                  <span className='go-textblacknormal-14 text-slate-500'>{capitalCaseFormatter(tx?.type)}</span>
                  <span className='go-textblacknormal-14 text-slate-500'>{dateFn('MM/DD/YYYY', tx?.created_date)}</span>
                </div>
              </div>
            ))}
          </div>
        </React.Fragment>
      )}
    </div>
  );
}
